import React from "react";
import PropTypes from 'prop-types';
import { TextField } from "@material-ui/core";

import "../styles.css"

const status = [
    { value: 'Ativada', label: 'Ativada' },
    { value: 'Desativada', label: 'Desativada' },
];

const nivelsResp = [
    { value: '#adcd98', label: 'Verde' },
    { value: '#f7d869', label: 'Amarelo' },
    { value: '#99ccff', label: 'Azul' },
    { value: '#e68a00', label: 'Laranja' },
    { value: '#dd0808', label: 'Vermelho' },
    { value: '#8c8c8c', label: 'Cinza' },
];

export default function BasicInfo(props) {
    const handleChange = (event) => {
        props.setValues({
            ...props.values,
            [event.target.id]: event.target.value,
        });
    };

    return (
        <>
            <div className="titles">Informações Gerais</div>
            <div className="fundo">
                <div className="rowForm">

                    <div className="auto6">
                        <TextField
                            disabled
                            margin="dense"
                            id="nome"
                            label="Usina"
                            value={props.values.nome}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="auto6">
                        <TextField
                            select
                            id="status"
                            size="small"
                            label="Status"
                            variant="outlined"
                            onChange={handleChange}
                            value={props.values.status}
                            SelectProps={{ native: true }}
                        >
                            {status.map((option) => (
                                <option key={option.value} value={props.values.status.value}>
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </div>

                    <div className="auto6">
                        <TextField
                            select
                            id="nivelResp"
                            size="small"
                            label="Nível de Resposta"
                            variant="outlined"
                            onChange={handleChange}
                            value={props.values.nivelResp}
                            SelectProps={{ native: true }}
                        >
                            {nivelsResp.map((option) => (
                                <option key={option.value} >
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </div>
                </div>
            </div>
        </>
    )
}

BasicInfo.propTypes = {
    update: PropTypes.bool,
    values: PropTypes.object,
    setValues: PropTypes.func
};
